import { default as Core } from './textField';
import ClearButton from './ClearButton';
import Count from './Count';
import Currency from './Currency';
import Error from './Error';
import HelperText from './HelperText';
import HelperWrapper from './HelperWrapper';
import Input from './Input';
import InputWrapper from './InputWrapper';
import Label from './Label';
import LeadingIcon from './LeadingIcon';
import TrailingButton from './TrailingButton';
import TrailingIcon from './TrailingIcon';

const TextField = Object.assign(Core, {
  ClearButton,
  Count,
  Currency,
  Error,
  Label,
  HelperText,
  HelperWrapper,
  Input,
  InputWrapper,
  LeadingIcon,
  TrailingIcon,
  TrailingButton,
});

export default TextField;
export type { Props as TextFieldProps } from './textField';
